function init() {
    const sectionIndustries = document.querySelector("section.industries-menu");

    if (sectionIndustries) {
        const dropdownList = sectionIndustries.querySelector(".dropdown-list");
        const subNav = sectionIndustries.querySelectorAll(".sub-nav");
        const itemNav = document.querySelectorAll(".dropdown-list > ul > li");

        // Establecer la altura mínima para el dropdownList
        dropdownList.style.minHeight = `${dropdownList.offsetHeight}px`;

        if (itemNav.length > 0) {
            // Asegurar que el primer elemento siempre tenga la clase "active" al inicio
            let activeIndex = 0;
            itemNav[activeIndex].classList.add("active");
            dropdownList.style.height = `${subNav[activeIndex].offsetHeight}px`;

            // Configurar eventos de clic para cada item de navegación
            for (let i = 0; i < itemNav.length; i++) {
                itemNav[i].addEventListener("click", function() {
                    if (itemNav[i].classList.contains("active")) {
                        return;
                    }

                    itemNav[activeIndex].classList.remove("active");
                    itemNav[i].classList.add("active");

                    activeIndex = i;

                    if (sectionIndustries.offsetWidth >= 1440) {
                        dropdownList.style.height = `${subNav[i].offsetHeight}px`;
                    }
                });
            }

            // Manejar el redimensionamiento de la ventana
            window.addEventListener("resize", () => {
                if (sectionIndustries.offsetWidth >= 1440) {
                    // Mantener el alto del dropdownList basado en el subNav del elemento activo
                    dropdownList.style.height = `${subNav[activeIndex].offsetHeight}px`;
                } else {
                    dropdownList.style.height = "min-content";
                }
            });
        }
    }
}

export default { init };
